import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
  Tooltip,
  Autocomplete,
  IconButton,
  Alert,
} from "@mui/material";
import PropTypes from "prop-types";

import { language } from "../../../../../language";
import GenericModal from "../../../../modal-closebtn/index";
import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";
import { getUniqueDocumentServiceFields } from "../../../../../util/camundaPropertiesPanelUtils";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { styled } from "@mui/material/styles";

const IconButtonAddStyled= styled(IconButton)(({ theme }) => ({
  borderRadius: '8px',
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties({
  jsonConfig,
  handleChangeConfigFields,
  handleChangeAutoCompleteConfigFields,
  handleChangeDocuments,
  handleChangeAutoCompleteDocuments,
  addDocuments,
  removeDocuments,
  classes,
  taskFields,
  businessObject,
}) {

  const documents = jsonConfig?.documents || [];

  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(getUniqueDocumentServiceFields(businessObject));

  documentVariables = documentVariables.filter((value, index, self) => {
    return index === self.findIndex((obj) => obj.id === value.id);
  }).map(value => value.id);

  const formFieldsVariables = 
    taskFields?.filter((taskField) => !documentVariables.some(docItem => docItem === taskField.id)) || [];

  return (
    <>
      <Grid item size={12} sx={{marginBottom: '20px', marginTop: '20px'}}>
        <Alert variant="outlined" severity="info">
          {language.modelerSignerResultInfo}
        </Alert>
      </Grid>

      <Grid item size={12} sx={{ height: '29px', marginBottom: '30px', marginTop: '20px'}}>
        <Typography variant="h6" sx={{fontWeight: '650'}}>{language.modelerSignatureResult}</Typography>
      </Grid>

      <Grid container size={12} spacing={3} sx={{ height: '56px'}} wrap="wrap" >
        {documents && documents.length > 0 ? 
          <>
            <Grid item size={{ xs: 12, sm: 6, md: 6}} justifyContent="flex-start" alignItems="center" sx={{ display: 'flex'}}>
              <Typography variant="body1" sx={{fontWeight: '600', marginRight: '10px'}}>{language.modelerSourceSignature}*</Typography>
              <Tooltip placement="right-start" title={
                  <Typography sx={{ fontSize: "17px", fontWeight: '600' }}>
                    {language.modelerTooltipSourceVariableUsedOnSignature}
                  </Typography>
                } 
              >
                <ErrorOutlineIcon sx={{ color: "#2A50DA"}} />
              </Tooltip>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 5}} justifyContent="flex-start" alignItems="center" sx={{ display: 'flex'}}>
              <Typography variant="body1" sx={{fontWeight: '600', marginRight: '10px'}}>{language.modelerDestinationSmartdocs}*</Typography>
              <Tooltip color="#2A50DA" placement="right-start" title={
                  <Typography sx={{ fontSize: "17px", fontWeight: '600' }}>
                    {language.modelerTooltipDestinationVariableWhereFileWillBeStored}
                  </Typography>
                } 
              >
                <ErrorOutlineIcon sx={{ color: "#2A50DA"}}  />
              </Tooltip>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 1}} justifyContent="flex-end" alignItems="center" sx={{ display: 'flex'}}>
              <Typography variant="body1" sx={{fontWeight: '600', textAlign: 'right'}}>{language.addRemove}</Typography>
            </Grid>
            {
              documents.map((s, index) => {

                return <Fragment key={`s${index}_${s.document}`}>
                  <Grid item size={{ xs: 12, sm: 6, md: 6}}>
                    <Autocomplete
                      value={documents[index]?.origem || ""}
                      onChange={(event, value) => handleChangeAutoCompleteDocuments(event, value, index, "origem")}
                      onInputChange={(event) => handleChangeDocuments(event, index, "origem")}
                      selectOnFocus
                      freeSolo
                      id={`s${index}_origem"`}
                      name="origem"
                      options={documentVariables}
                      getOptionLabel={(formField) => { 
                        if(typeof formField === 'string'){
                          return formField;
                        } 
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          name="origem"
                          required
                          label={language.modelerSourceSignature}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 5}}>
                    <Autocomplete
                      value={documents[index]?.destino || ""}
                      onChange={(event, value) => handleChangeAutoCompleteDocuments(event, value, index, "destino")}
                      onInputChange={(event) => handleChangeDocuments(event, index, "destino")}
                      selectOnFocus
                      freeSolo
                      id={`s${index}_destino`}
                      name="destino"
                      options={documentVariables}
                      getOptionLabel={(formField) => { 
                        if(typeof formField === 'string'){
                          return formField;
                        } 
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          name="destino"
                          required
                          label={language.modelerDestinationSmartdocs}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 1}} justifyContent="flex-end" alignItems="center" sx={{ display: 'flex'}}>
                    {documents.length == 1
                      ? (
                        <IconButtonAddStyled
                          size="small"
                          color="primary"
                          onClick={addDocuments}
                        >
                          <AddIcon />
                        </IconButtonAddStyled>
                      )
                      : (
                        <IconButton
                          size="small"
                          color="primary"
                          sx={{
                            borderRadius: '8px',
                            border: '1px solid'
                          }}
                          onClick={(event) => {
                            removeDocuments(event, index);
                            if(documents.length == 0){
                              // não deixa a lista ficar sem items 
                              // (só para garantir que o comportamento do botão adicionar continue aparecendo no primeiro item da lista)
                              addDocuments();
                            }
                          }}
                        >
                          <RemoveIcon />
                        </IconButton>
                      )
                    }
                  </Grid>
                </Fragment>

              })
            }
          </>
          : <Grid item size={12} justifyContent="center" alignItems="center" sx={{ display: 'flex'}} >
              <Typography variant="body1" sx={{fontWeight: '400'}}>{language.noMetadataSelected}</Typography>
           </Grid>
        }
        <Grid item size={{ xs: 12, sm: 6, md: 11}}></Grid>
        {!(documents.length == 1) &&
          <Grid item size={{ xs: 12, sm: 6, md: 1}} justifyContent="flex-end" alignItems="center" sx={{ display: 'flex'}}>
            <IconButtonAddStyled
                size="small"
                color="primary"
                onClick={addDocuments}
              >
                <AddIcon />
              </IconButtonAddStyled>
          </Grid>
        }
      </Grid>

    </>
  );
}

// CUSTOMIZA AS AÇÔES DO MODAL
function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

// Componente

function ModelerIntegrarAssinaturaLoteGetResult({
  saveIntegrarAssinaturaLoteGetResultConfig, // modeler
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
  theme, // tema
  classes,
}){
  const [jsonConfig, setJsonConfig] = useState({
    documents: [],
  })
  
  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "xl",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });

  const [hasConfigError, setHasConfigError] = useState(false);

  const [open, setOpen] = useState(true);

  // EFFECT 1 - preenche o state com os dados do modeler
  useEffect(() => {

    if(inputValues){

      let documents = inputValues?.documents || [];

      if(documents.length == 0){
        // inicia o compontente com 1 item com dados em branco
        documents.push({
          origem: "",
          destino: "",
        });
      }

      setJsonConfig({
        documents: documents,
      });
    } else{

      // inicia o compontente com 1 item com dados em branco
      setJsonConfig({
        documents: [
          {
            origem: "",
            destino: "",
          }
        ],
      });
    }

  }, [inputValues]);

  const handleClose = () => {
    setOpen(false);
  };

  //gerencia state das abas
  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev, 
      tabValue: newValue
    }));
  };

  const validateConfig = (obj) => {
    let erros = [];

    return erros;
  }

  const handleSave = () => {

    const documents = jsonConfig?.documents || [];

    const inputObject = {
      documents: documents,
    }

    const erros = validateConfig(inputObject)

    if(erros.length > 0){
      setHasConfigError(erros);
    } else{

      //salvando no modeler
      saveIntegrarAssinaturaLoteGetResultConfig(
        businessObject,
        element,
        extensionElements,
        bpmnFactory,
        inputObject,
      );

      handleClose();
    }
  }

  const handleChangeConfigFields = (event) => {
    if(!event?.target) return;

    const { name, value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeAutoCompleteConfigFields = (event, value, name) => {
    if(!event?.target) return;

    let newValue;
    if(typeof value === 'string'){
      newValue = value;
    } else if(value?.id){
      newValue = value.id;
    } else{
      newValue = value;
    }

    setJsonConfig((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  }

  const handleChangeDocuments = (event, index, name) => {
    if(!event?.target) return;

    const { value } = event.target;
    let documents = jsonConfig?.documents || [];

    documents[index] = {
      ...documents[index],
      [name]: value,
    }

    setJsonConfig((prev) => ({
      ...prev,
      documents: documents
    }));
  };

  const handleChangeAutoCompleteDocuments = (event, value, index, name, attributeField) => {
    if(!event?.target) return;
    
    let documents = jsonConfig?.documents || [];

    let newValue;
    if(typeof value === 'string'){
      newValue = value;
    } else if(value?.id){
      newValue = value.id;
    } else if(attributeField && value?.[attributeField]){
      newValue = value[attributeField];
    } else{
      newValue = value;
    }

    documents[index] = {
      ...documents[index],
      [name]: newValue,
    }

    setJsonConfig((prev) => ({
      ...prev,
      documents: documents
    }));
  };

  const addDocuments = () => {
    let documents = jsonConfig?.documents || [];

    documents.push({
      origem: "",
      destino: "",
    });

    setJsonConfig((prev) => ({
      ...prev,
      documents: documents
    }));
  };

  const removeDocuments = (event, index) => {
    let documents = jsonConfig?.documents || [];

    documents.splice(index, 1);
    
    setJsonConfig((prev) => ({
      ...prev,
      documents: documents
    }));
  };

  const { tabValue } = state;

  return (
    open && (
        <GenericModal
          title={language.configuration}
          handleClose={handleClose}
          size={state.maxWidth}
          open={true}
          handleSubmit={handleSave}
          btnActionTitle={language.save}
          btnCancelTitle={language.cancel}
          overrideDialogActions={() =>
            OverrideModalActions({
              handleSubmit: handleSave,
              handleClose: handleClose,
            })
          }
        >
          <div style={{ height: "75vh" }}>
            <Grid container direction="row">
              <Grid item size={12}>
                <Tabs
                  value={tabValue}
                  indicatorColor="secondary"
                  textColor="secondary"
                  onChange={handleChangeTab}
                >
                  <Tab label={language.properties} />
                  <Tab label={language.configuration} disabled />
                  <Tab label={language.permissions} disabled />
                </Tabs>
              </Grid>

              <Grid item size={12} sx={{padding: "1% 1%",}}>
                <TabPanel value={tabValue} index={0}>
                  <TabProperties
                    businessObject={businessObject}
                    taskFields={FormComponents}
                    classes={classes}
                    jsonConfig={jsonConfig}
                    handleChangeConfigFields={handleChangeConfigFields}
                    handleChangeAutoCompleteConfigFields={handleChangeAutoCompleteConfigFields}
                    handleChangeDocuments={handleChangeDocuments}
                    handleChangeAutoCompleteDocuments={handleChangeAutoCompleteDocuments}
                    addDocuments={addDocuments}
                    removeDocuments={removeDocuments}
                  />
                </TabPanel>
               
              </Grid>
            </Grid>

            {hasConfigError && (
                <GenericSnackbar
                  errorWithChildren={true}
                    message={
                      <div>
                        {hasConfigError.map((err, index) => {
                            return <div
                              key={`errorMessage_${index}`}
                            >
                              {err}
                            </div>;
                          })
                        }
                      </div>
                    }
                    handleClose={() => setHasConfigError(false)}
                    duration={4000}
                />
              )}

          </div>
        </GenericModal>
    )
  );
}

export default ModelerIntegrarAssinaturaLoteGetResult;
